import * as GetAssetConstants from '../../constants/General'
import { updateTab , addActionInTab} from "../Tabs"
import uuid from 'uuid/v1'
import qs from 'qs'
const fs = require('fs')

const path = require('path')
const os = require('os')
// this function is to add ftp Get container

export const AddGetAsset = (parentId = null) => {
  return (dispatch, getState) => {
    let { tabs, currentTab } = getState()
    let tab = tabs[currentTab]
    console.log("tabtab",tab);
    let action = {
      id : uuid(),
      type : GetAssetConstants.GET_CREDENTIALS,
      label : "Get Credentials",
      key : "GetCredentials",
      allowNesting : false,
      AssetName: "",
      variable: "",
      UserName: "",
      Password: "",
      variableName : '',
      instruction : "",
      parentId:parentId,
      status:false
    }
    tab = addActionInTab(tab, action, parentId)
    dispatch(updateTab(tab))
  }
}
// this function is to edit ftp Get container
export const EditGetAsset = (payload,actionId=null) => {
  return (dispatch, getState) => {
    let { tabs, currentTab} = getState()
    let tab = tabs[currentTab]
    let {currentAction} = tab
    let AssetAction = tab["actions"][actionId ? actionId : currentAction]
    let config={}
    let TokenData={}
    let temp = {
      ...AssetAction,
      ...payload
    }
    if(temp.AssetName!=""&& temp.UserName!=""&temp.Password!=""){
      temp.status = true
    }
    else{
      temp.status=false
    }
    if(fs.existsSync(path.join(os.tmpdir(),"TechforceAuthentication")))
    {
      config = JSON.parse(fs.readFileSync(path.join(os.tmpdir(),"TechforceAuthentication"),"utf8"))
    }
    else{
      console.log("file does not exit")
    }
    console.log("temptemptemp get",temp);console.log
    (config);
    let options = qs.stringify({
      username: config.name,
     password: config.password,
     grant_type:"password",
     client_id: "admin-cli"
   })
   console.log("options=======", options)
   let api = `${config.ip}/v1/csrftoken`
   //let instruction = `api_config = {method:'POST' ,header:["Content-Type:application/x-www-form-urlencoded"],body:"username=${config.name}&password=${config.password}&grant_type=password&client_id=admin-cli"}; \n api ${remote.process.env.KEYCLOAK_AUTHENTICATION_URL} \n token_data = api_json \n api_config = {method:'GET',  header:[ 'Authorization: Bearer \`token_data.access_token\`']} \n api ${api} \n tf_967479873123kjasdbasjdnkejfgfadrjueihwrk = api_json.secret_id \n api_config = {method:'GET',  header:[ 'Authorization: Bearer \`token_data.access_token\`']} \n api  ${config.ip}/v1/vault/\`tf_967479873123kjasdbasjdnkejfgfadrjueihwrk\` \n ${temp.UserName}=api_json[tf_967479873123kjasdbasjdnkejfgfadrjueihwrk].username \n blind updateSecureEntry('${temp.Password}',${temp.Password} , api_json[tf_967479873123kjasdbasjdnkejfgfadrjueihwrk].password)`
   let instruction = `api_config={method:'POST' ,header:["Content-Type:application/x-www-form-urlencoded"],body:"username=${config.name}&password=${config.password}&grant_type=password&client_id=admin-cli"} \n api ${config.baseUrl}/protocol/openid-connect/token \n token_data = api_json.access_token \n api_config = {method:'GET',  header:[ ]} \n api ${api} \n csrf_token = api_json.csrfToken \n api_config = {method:'GET',  header:[ 'Authorization: Bearer \`token_data\`','X-Frame-Options:sameorigin','set_cookie:HttpOnly','strict-transport-security:max-age=31536000; includeSubDomains','Public-Key-Pins:pin-sha256="AbCdEf123="; pin-sha256="ZyXwVu456=";max-age=2592000; includeSubDomains','X-XSS-Protection:1; mode=block','x-content-type-options:nosniff','X-Download-Options:noopen','csrfToken:\`csrf_token\`']} \n api ${config.ip}/v1/vault/getUniqueId?secret_name=${temp.AssetName}\n ${temp.UserName}=api_json.username \n ${temp.Password} = api_json.password`
   tab["actions"][actionId ? actionId : currentAction] = {
     ...temp,
     instruction : instruction,
     description:"Gets the Secret Data from vault "
   }
  dispatch(updateTab(tab))
 }
}

   

